export const cardsInit = () => {
    let $card_elem = $('.card-overlay:visible');
    $card_elem.each(function () {
        $(this)
            .closest('.card-with-overlay')
            .css('min-height', $(this).height() + 'px');
    });
};
